exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".resources-editor{\r\n    font-size:12px;\r\n    padding:15px;\r\n}\r\n\r\n.resource-row{\r\n    line-height: 32px;\r\n    height: 32px;\r\n    border-bottom: 1px solid lightgrey;\r\n}\r\n\r\n.resource-header{\r\n    margin-top:3px;\r\n    line-height: 35px;\r\n    height: 35px;\r\n    border-bottom: 1px solid lightgrey;\r\n}\r\n\r\n.fa-times{\r\n    display: inline-block;\r\n    padding:0 4px;\r\n    color:maroon;\r\n    cursor: pointer;\r\n} \r\n\r\n.fa-check{\r\n    display: inline-block;\r\n    padding:0 4px;\r\n    color:limegreen;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/src/app/resources-editor/resources-editor.component.css
// module id = ../../../../../src/app/resources-editor/resources-editor.component.css
// module chunks = 1